function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4622 11.3655C19.4622 10.6556 19.4046 10.1376 19.2799 9.60034H11.1733V12.8046H15.9317C15.8358 13.6009 15.3178 14.8001 14.1665 15.6059L14.1504 15.7131L16.7135 17.6988L16.8911 17.7165C18.522 16.2103 19.4622 13.9942 19.4622 11.3655Z",
  fill: "#4285F4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1732 19.8071C13.5044 19.8071 15.4615 19.0395 16.891 17.7157L14.1664 15.605C13.4373 16.1135 12.4587 16.4684 11.1732 16.4684C8.88996 16.4684 6.95208 14.9623 6.26127 12.8805L6.16002 12.8891L3.49482 14.9517L3.45996 15.0486C4.8798 17.8691 7.79625 19.8071 11.1732 19.8071Z",
  fill: "#34A853"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.26085 12.8811C6.07857 12.3438 5.97308 11.7682 5.97308 11.1734C5.97308 10.5786 6.07857 10.003 6.25126 9.46573L6.24643 9.35131L3.54783 7.25555L3.45954 7.29755C2.87435 8.46798 2.53857 9.78233 2.53857 11.1734C2.53857 12.5645 2.87435 13.8787 3.45954 15.0492L6.26085 12.8811Z",
  fill: "#FBBC05"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1732 5.87712C12.7945 5.87712 13.8882 6.57745 14.5118 7.16269L16.9485 4.78347C15.452 3.39241 13.5044 2.53857 11.1732 2.53857C7.79625 2.53857 4.8798 4.47646 3.45996 7.29695L6.25168 9.46513C6.95208 7.38333 8.88996 5.87712 11.1732 5.87712Z",
  fill: "#EB4335"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.5037731e.svg";
export { ForwardRef as ReactComponent };